var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React, { Component } from 'react';
import { range, isEqual } from 'lodash';
import moment from 'moment';
import { default as AntTimePicker } from 'antd/lib/time-picker';
import { globalConfig } from '@comall-backend-builder/core';
import { services } from '@comall-backend-builder/core';

var TimePicker = function (_super) {
  __extends(TimePicker, _super);

  function TimePicker(props) {
    var _this = _super.call(this, props) || this;

    _this.disabledHours = function () {
      var format = _this.format;
      if (!_this.props.range) return [];
      var _a = _this.props.range,
          start = _a.start,
          end = _a.end;
      var startHour = start ? moment(start, format).hour() : 0;
      var endHour = end ? moment(end, format).hour() : 23;
      return range(0, startHour).concat(range(endHour + 1, 24));
    };

    _this.disabledMinutes = function (selectedHour) {
      var format = _this.format;
      if (!_this.props.range) return [];
      var _a = _this.props.range,
          start = _a.start,
          end = _a.end;
      var startMinute = 0;
      var endMinute = 59;

      if (start) {
        var startTime = moment(start, format);

        if (selectedHour === startTime.hour()) {
          startMinute = startTime.minute();
        }
      }

      if (end) {
        var endTime = moment(end, format);

        if (selectedHour === endTime.hour()) {
          endMinute = endTime.minute();
        }
      }

      return range(0, startMinute).concat(range(endMinute + 1, 60));
    };

    _this.disabledSeconds = function (selectedHour, selectedMinute) {
      var format = _this.format;
      if (!_this.props.range) return [];
      var _a = _this.props.range,
          start = _a.start,
          end = _a.end;
      var startSecond = 0;
      var endSecond = 59;

      if (start) {
        var startTime = moment(start, format);

        if (selectedHour === startTime.hour() && selectedMinute === startTime.minute()) {
          startSecond = startTime.second();
        }
      }

      if (end) {
        var endTime = moment(end, format);

        if (selectedHour === endTime.hour() && selectedMinute === endTime.minute()) {
          endSecond = endTime.second();
        }
      }

      return range(0, startSecond).concat(range(endSecond + 1, 60));
    };

    _this.format = globalConfig.get('format.time') || '';
    _this.onChange = services.pickerHelper.onChange.bind(_this);
    return _this;
  }

  TimePicker.prototype.shouldComponentUpdate = function (nextProps) {
    return !isEqual(this.props, nextProps);
  };

  TimePicker.prototype.render = function () {
    var format = this.format;
    var _a = this.props,
        className = _a.className,
        style = _a.style,
        value = _a.value,
        _b = _a.format,
        renderFormat = _b === void 0 ? format : _b,
        _c = _a.placeholder,
        placeholder = _c === void 0 ? services.language.getText('common.pleaseSelect') : _c,
        disabled = _a.disabled,
        allowClear = _a.allowClear;
    var antValue;

    if (value) {
      antValue = moment(value, format);
    }

    var props = {
      className: className,
      style: style,
      value: antValue,
      format: renderFormat,
      placeholder: placeholder,
      disabled: disabled,
      allowClear: allowClear,
      onChange: this.onChange,
      disabledHours: this.disabledHours,
      disabledMinutes: this.disabledMinutes,
      disabledSeconds: this.disabledSeconds
    };
    return React.createElement(AntTimePicker, __assign({}, props));
  };

  return TimePicker;
}(Component);

export { TimePicker };